.pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: var(--radius-pill);
  border: 1px solid transparent;
  font-weight: 500;
  white-space: nowrap;
  line-height: 1.4;
}

.xs {
  font-size: 10px;
  padding: 0 6px;
  font-weight: 600;
}

.sm {
  font-size: var(--text-micro);
  padding: 1px 8px;
}

.md {
  font-size: 12px;
  padding: 2px 10px;
}

.neutral {
  background: var(--c-info-subtle);
  color: var(--c-text-secondary);
}

.brand {
  background: var(--c-brand-subtle);
  color: var(--c-brand-muted);
}

.pos {
  background: var(--c-positive-subtle);
  color: var(--c-positive);
}

.neg {
  background: var(--c-negative-subtle);
  color: var(--c-negative);
}

.warn {
  background: var(--c-warning-subtle);
  color: var(--c-warning);
}

.info {
  background: var(--c-info-subtle);
  color: var(--c-info);
}

.outline {
  background: transparent;
  border-color: var(--c-border);
  color: var(--c-text-tertiary);
}

.dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex: none;
  display: inline-block;
}

.dot_neutral,
.dot_outline,
.dot_info {
  background: var(--c-text-tertiary);
}

.dot_brand {
  background: var(--c-brand);
}

.dot_pos {
  background: var(--c-positive);
}

.dot_neg {
  background: var(--c-negative);
}

.dot_warn {
  background: var(--c-warning);
}

.live {
  box-shadow: 0 0 0 3px var(--glow);
  animation: pulse 1.6s ease-in-out infinite;
}

@keyframes pulse {
  50% {
    box-shadow: 0 0 0 5px transparent;
  }
}

.status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}

.text_neutral,
.text_outline,
.text_info {
  color: var(--c-text-secondary);
}

.text_brand {
  color: var(--c-brand-muted);
}

.text_pos {
  color: var(--c-positive);
}

.text_neg {
  color: var(--c-negative);
}

.text_warn {
  color: var(--c-warning);
}

.kbd {
  font-family: var(--font-mono);
  font-size: var(--text-micro);
  font-weight: 500;
  border: 1px solid var(--c-border-strong);
  border-radius: var(--radius-xs);
  padding: 0 6px;
  color: var(--c-text-tertiary);
  background: none;
}
